import { render } from "./SignUpPage.vue?vue&type=template&id=1d61217c&scoped=true&ts=true"
import script from "./SignUpPage.vue?vue&type=script&lang=ts"
export * from "./SignUpPage.vue?vue&type=script&lang=ts"

import "./SignUpPage.vue?vue&type=style&index=0&id=1d61217c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d61217c"]])

export default __exports__